import { types } from 'mobx-state-tree';
import { rootCategoryId } from 'eTip--common';

export const CategoryStore = types
    .model({
        //from api
        id: types.optional(types.string, rootCategoryId),
        level: types.number,  //1-4
        name: types.maybeNull(types.string),
        parentId: types.maybeNull(types.string),
        backgroundColor: types.maybeNull(types.string),
        isVirtual: types.maybeNull(types.boolean),
        categoriesIds: types.maybeNull(types.array(types.string)), // level 1,2,3
        graphicsPresentationId: types.maybeNull(types.number), //expected at level 2

        //custom
        parentKey: types.string,
        expanded: types.maybeNull(types.boolean),
        hasLive: types.maybeNull(types.boolean),
    })
    .views(self => {
        return {
            get key() {
                return !!self.parentKey ? `${self.parentKey}c${self.id}` : `${self.id}`;
            }
        };
    })
    .actions(self => {
        return {
            toggle: () => {
                self.expanded = !self.expanded;
            }
        };
    });
